import { createReducer } from "@reduxjs/toolkit";
import { AppStateManager } from "common/helpers/app-state-manager.utils";
import { UserFormValues } from "models/login";
import AuthService from "../auth.service";
import {
	authAuthorize,
	authLogout,
	authRecuperaPraticaEmail,
	authSetUser,
	authVerifyOTP,
} from "./action";

interface AuthReducer {
	sessionId: string | undefined;
	token: string | undefined;
	user: UserFormValues | undefined;
	recuperaPraticaEmail: string | undefined;
}

const initialState: AuthReducer = {
	sessionId: undefined,
	token: undefined,
	user: AppStateManager.getUserInfo() || undefined,
	recuperaPraticaEmail: undefined,
};

export const authReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(authAuthorize.fulfilled, (state, { payload }) => {
			state.sessionId = payload?.sessionId;
		})
		.addCase(authLogout, () => {
			AppStateManager.cleanState();
		})
		.addCase(authVerifyOTP.fulfilled, (state, { payload }) => {
			if (payload?.idToken) {
				state.token = payload?.idToken;
				AuthService.setAuthentication(payload?.idToken);
			}
		})
		.addCase(authSetUser, (state, { payload }) => {
			state.user = payload;
			AppStateManager.setUserInfo(payload);
		})
		.addCase(authRecuperaPraticaEmail, (state, { payload }) => {
			state.recuperaPraticaEmail = payload;
		});
});
